module.exports = __webpack_public_path__ + "static/media/eyeliner.f9faf98f.png";